import styled from 'styled-components';
import { Input, Checkbox, Form } from 'antd';

export const RangeInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 16px;
`;

export const Title = styled.h3`
  margin-top: 10px;
  margin-bottom: 28px;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: ${props => props.theme.colors.black};
`;

export const RangeInputsWrapper = styled.div`
  display: flex;
`;

export const RangeDivider = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.black};
  width: 6px;
  margin: 26px 8px 19px 8px;
`;

export const RangeLabelText = styled.label`
  font-size: 13px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.fontLightBlack};
`;

export const BudgetInput = styled(Input)`
  max-width: 290px;

  input {
    border-radius: 3px;
    padding: 10px 7px;
    height: 38px;
    border: 1px solid ${({ theme }) => theme.colors.borderLightestSilver};
    color: ${({ theme }) => theme.colors.mainDark};

    ::placeholder {
      color: ${({ theme }) => theme.colors.secondaryDark};
      font-size: 14px;
    }
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const BudgetInputPrefix = styled.div`
  opacity: 0.5;
  color: ${({ theme }) => theme.colors.secondaryDark};
  border-right: none;
`;

export const BudgetCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({ theme }) => theme.colors.lightGreen};
    border-color: ${({ theme }) => theme.colors.lightGreen};
  }
`;

export const RangeButtonWrapper = styled.div`
  margin-top: 25px;
  text-align: center;
`;

const FormItem = Form.Item;

export const FormItemS = styled(FormItem)`
  max-width: 108px;
  margin: 5px 0 8px 0;
  text-align: left;
  font-size: 13px;

  .has-error .ant-form-explain,
  .has-error .ant-form-split {
    margin-top: 2px;
    margin-bottom: -15px;
  }
`;

export const FormErrorWrapper = styled(FormItem)`
  margin-bottom: 0;

  .ant-form-item-control .has-error {
   margin-bottom: ${({ message }) => message ? '24px' : '0'};
  }
`;

export const DeleteBudgetWrapper = styled.div`
  display: flex;   
  justify-content: center;
  align-items: center;
  cursor: pointer;   
  color: ${({ theme }) => theme.colors.red}
`;

export const BudgetActionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;



// WEBPACK FOOTER //
// ./src/modals/budget-modal/styled-components.js